class FileData {
  constructor({ _id = null, mimetype = '', name = '', url = '' }) {
    this.id = _id;
    this.mimetype = mimetype;
    this.name = name;
    this.url = url;
  }
}

export default FileData;
